import { bestellwegIcon } from '@/lib/bestellwegIcons';

export function QuelleIcon({ icon, label }: { icon: string | null; label: string }) {
  // Die Zuordnung steht seit A40 in lib/bestellwegIcons.ts — sie stand
  // hier und im BestellwegPicker zweimal gleich.
  const Icon = bestellwegIcon(icon);
  return (
    <span className="inline-flex h-6 w-6 items-center justify-center text-ink-soft" title={label}>
      <Icon className="h-4 w-4" />
    </span>
  );
}
